import { Button } from '@mm/components';
import { selectXRayAnalytics } from '@mm/state/selectors/botAnalyticsSelector';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';
import { Spin } from 'antd';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { BotBuilderRoutes } from '../../../../../../../routes/bot-builder-routes';
import styles from '../AnalyticsCharts/AnalyticsCharts.module.css';

export const calcPercentage = (total: number, value: number) => {
  if (total) {
    return ((value / total) * 100).toFixed(2);
  }
};

export const XRayContactsByLandingPage = ({ busy }: { busy?: boolean }) => {
  const chatbotId = useSelector(activeChatbotIdSelector);
  const xRayAnalytics = useSelector(selectXRayAnalytics).top_urls;
  const { total, landingPageUrl, hits } = xRayAnalytics || {};

  const history = useHistory();

  const onClick = () => {
    history.push(BotBuilderRoutes.xRay.getLink({ chatbotId }));
  };

  return (
    <div className={styles.container} style={{ maxWidth: '480px' }}>
      <div className={styles.header}>Contacts by Landing Pages</div>
      <Spin
        tip="Calculating..."
        size="small"
        spinning={busy}
        wrapperClassName={classNames(styles.spin, {
          [styles.busySpin]: busy,
        })}
      >
        {total && !busy ? (
          <div className={styles.landingsContainer}>
            {landingPageUrl?.map((url, index) => {
              const percentage = calcPercentage(total, hits?.[index] || 0);
              return (
                <div key={url} className={classNames(styles.landingBlock)}>
                  <div className={styles.statsBarRow}>
                    <div
                      className={styles.statsBar}
                      style={{ width: `${percentage}%` }}
                    />
                    <div className={styles.statsRow}>
                      <span className={styles.percentage}>{percentage}%</span>
                      <span className={styles.hits}>
                        {hits?.[index]?.toLocaleString()}
                      </span>
                    </div>
                  </div>
                  <span>{url}</span>
                </div>
              );
            })}
          </div>
        ) : (
          <div className={styles.landingsContainer} key={uniqueId()}>
            {[...Array(4)].map(_ => (
              <div key={uniqueId()} className={classNames(styles.landingBlock)}>
                <div className={styles.statsBarRow}>
                  <div className={styles.statsBar} style={{ width: '2px' }} />
                  <div className={styles.statsRow}>
                    <span className={styles.percentage}>0</span>
                  </div>
                </div>
                <span style={{ color: '#8C8C8C' }}>
                  Your website page we can gather contacts from
                </span>
              </div>
            ))}
            <Button css={{ container: styles.actionBtn }} onClick={onClick}>
              Install X-Ray to gather your website visitors{' '}
            </Button>
          </div>
        )}
      </Spin>
    </div>
  );
};
